import React from 'react';
import styles from './styles.module.css';
import { Button, Grid, DialogActions } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import { Trans, useTranslation } from 'react-i18next';

function EstimateUpdateSuccessDialog(props) {
  const { handleClose, data, printFn } = props;
  const { t: tCommon } = useTranslation('common');
  const { t: tPopup } = useTranslation('popup');

  return (
    <div className={styles.popUp}>
      <div className={styles.contentWrapperSm}>
        <div className={styles.headSec}>
          <h2 className={styles.editTitle}>
            {tPopup('Estimate {{action}} successfully', {
              action: data.action === 'Create' ? tCommon('created') : tCommon('updated'),
            })}
          </h2>
        </div>
        <div className={styles.inputSec}>
          <Grid container spacing={2}>
            <Grid item xs={12} sx={{ padding: '16px 10px' }}>
              <span className={styles.msg}>
                <Trans
                  i18nKey="popup:estimate_success_message"
                  values={{
                    invoiceNo: data.invoiceNo,
                    action: data.action === 'Create' ? tCommon('created') : tCommon('updated'),
                  }}
                  components={{ strong: <strong /> }}
                />
              </span>
            </Grid>
          </Grid>
        </div>
        <div className={styles.footSec}>
          <DialogActions>
            <Button
              variant="contained"
              className={styles.btnView}
              sx={{ mr: 1 }}
              onClick={() => printFn(data.invoiceNo)}
            >
              <PrintIcon className={styles.iconView} /> {tCommon('Print')}
            </Button>
            <Button variant="contained" color="primary" className={styles.btnView} onClick={handleClose}>
              {tCommon('Close')}
            </Button>
          </DialogActions>
        </div>
      </div>
    </div>
  );
}

export default EstimateUpdateSuccessDialog;
